export class UserMasterModel {

  UserMasterListAPI: string = "";
  UpdateAPI: string = "";
  UserByIDAPI: string = "";
  SendVerificationOtpAPI: string = "";
  CheckUserNameIsExistAPI: string = "";
  GetRolesAPI: string = "";
  GetbloodgroupAPI: string = "";
  GetLocationAPI: string = "";
  GetUserTypeAPI: string = "";
  PublisherList: string = "";
  GetActivityList: string = "";
  JournalList: string = "";
  DepartmentDropdownapi: string = "";
  publisherMasterList: any;
  journalMasterList: any;
  activityList:any
  JrlIDListPop: any;
  autoAssignApi: string = "";
} 
